<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="row col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Criação de Capacitação
          <q-icon
            style="cursor: pointer"
            name="info"
            @click="informacao = true"
          />
        </p>
        <div class="q-ml-lg col-md-3 col-sm-5 col-xs-5">
          <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
        </div>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <label
            class="btn-upload row col-12"
            for="arquivo"
            style="cursor: pointer"
          >
            <div class="col-12 q-mt-md">
              <q-btn
                icon="upload"
                label="Selecionar Arquivo"
                color="primary"
                style="z-index: -1"
                class="btn"
                no-caps
                outline
                dense
              />
              <span class="q-mt-sm q-ml-sm texto-upload">{{
                file != null ? file.name : "Nenhum arquivo selecionado"
              }}</span>
            </div>
          </label>
          <input id="arquivo" type="file" @change="onFileSelected" />
        </div>
      </div>
      <div class="btn-gerar-container">
        <p></p>
        <q-btn
          class="q-mt-sm btn-enviar"
          icon="check_circle_outline"
          label="Enviar"
          color="positive"
          dense
          no-caps
          @click="enviarArquivo()"
        />
      </div>
    </div>
    <div class="row q-gutter-sm q-mt-xl">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Associação de Produtos
          <q-icon
            style="cursor: pointer"
            name="info"
            @click="informacaoAssociacaoGrupos = true"
          />
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <label
            class="btn-upload row col-12"
            for="arquivoAssociacaoGrupo"
            style="cursor: pointer"
          >
            <div class="col-12 q-mt-md">
              <q-btn
                icon="upload"
                label="Selecionar Arquivo"
                color="primary"
                style="z-index: -1"
                class="btn"
                no-caps
                outline
                dense
              />
              <span class="q-mt-sm q-ml-sm texto-upload">{{
                fileAssociacaoGrupos != null
                  ? fileAssociacaoGrupos.name
                  : "Nenhum arquivo selecionado"
              }}</span>
            </div>
          </label>
          <input
            id="arquivoAssociacaoGrupo"
            type="file"
            @change="onFileSelectedGrupos"
          />
        </div>
      </div>
      <div class="btn-gerar-container">
        <p></p>
        <q-btn
          class="q-mt-sm btn-enviar"
          icon="check_circle_outline"
          label="Enviar"
          color="positive"
          dense
          no-caps
          @click="enviarArquivoAssociacaoGrupos()"
        />
      </div>
    </div>
    <div class="row q-gutter-sm q-mt-xl">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Criação de treinamento
          <q-icon
            style="cursor: pointer"
            name="info"
            @click="informacaoTreinamento = true"
          />
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <label
            class="btn-upload row col-12"
            for="arquivoTreinamento"
            style="cursor: pointer"
          >
            <div class="col-12 q-mt-md">
              <q-btn
                icon="upload"
                label="Selecionar Arquivo"
                color="primary"
                style="z-index: -1"
                class="btn"
                no-caps
                outline
                dense
              />
              <span class="q-mt-sm q-ml-sm texto-upload">{{
                fileTreinamento != null
                  ? fileTreinamento.name
                  : "Nenhum arquivo selecionado"
              }}</span>
            </div>
          </label>
          <input
            id="arquivoTreinamento"
            type="file"
            @change="onFileSelectedTreinamento"
          />
        </div>
      </div>
      <div class="btn-gerar-container">
        <p></p>
        <q-btn
          class="q-mt-sm btn-enviar"
          icon="check_circle_outline"
          label="Enviar"
          color="positive"
          dense
          no-caps
          @click="enviarArquivoTreinamento()"
        />
      </div>
    </div>
    <q-dialog v-model="informacao">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/controle-funcao/padrao_treinamento_em_massa_r1.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="1" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Não altere a ordem das colunas nem o texto, isso trará problema
                na importação
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="2" class="column no-wrap flex-center">
              <q-icon name="delete" size="56px" />
              <div class="q-mt-md text-center">
                APAGUE as informações da linha 2 e preencha com seus valores
                reais
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="3" class="column no-wrap flex-center">
              <q-icon name="view_column" size="56px" />
              <div class="q-mt-md text-center">
                A coluna A (sap) refere-se ao ID do colaborador
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="4" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Se houver erro de digitação na coluna B (treinamento) o sistema
                irá cirar outro treinamento com esse "novo" nome.
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="5" class="column no-wrap flex-center">
              <q-icon name="event" size="56px" />
              <div class="q-mt-md text-center">
                A validade do treinamento é em dias.
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="informacaoAssociacaoGrupos">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slideAssocoacaoGrupos"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/treinamento/Associacao_de_Pessoas_vs_Treinamentos.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="informacaoTreinamento">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a
                download
                href="https://multpex-docs.s3.amazonaws.com/templates/treinamento/Criacao_Treinamentos.xlsx"
              >
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="1" class="column no-wrap flex-center">
              <q-icon name="do_not_disturb" size="56px" />
              <div class="q-mt-md text-center">
                Não altere a ordem das colunas nem o texto, isso trará problema
                na importação
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="2" class="column no-wrap flex-center">
              <q-icon name="delete" size="56px" />
              <div class="q-mt-md text-center">
                APAGUE as informações da linha 2 e preencha com seus valores
                reais
              </div>
            </q-carousel-slide>
            <q-carousel-slide :name="3" class="column no-wrap flex-center">
              <q-icon name="event" size="56px" />
              <div class="q-mt-md text-center">
                A validade do treinamento é em dias.
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const file = ref(null);
    const fileAssociacaoGrupos = ref(null);
    const fileTreinamento = ref(null);
    let informacao = ref(false);
    let informacaoAssociacaoGrupos = ref(false);
    let informacaoTreinamento = ref(false);
    const arquivoUrl = ref("");
    const arquivoAssociacaoGruposUrl = ref("");
    const arquivoTreinamento = ref("");
    let slide = ref(0);
    let slideAssocoacaoGrupos = ref(0);

    const onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      file.value = e.target.files[0];
    };

    const onFileSelectedGrupos = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      fileAssociacaoGrupos.value = e.target.files[0];
    };

    const onFileSelectedTreinamento = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }
      fileTreinamento.value = e.target.files[0];
    };

    const enviarArquivo = async () => {
      if (file.value == null) {
        quasar.notify({
          message: "Selecione um arquivo primeiro",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (file.value.name.split(".").pop() != "xlsx") {
        quasar.notify({
          message: "O arquivo tem que ser do tipo .xlsx",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("treinamento/uploadCapacitacao", {
          unidadeId: unidade.value.id,
          arquivo: arquivoUrl.value.split("base64,")[1],
        });
        quasar.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        file.value = null;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarArquivoAssociacaoGrupos = async () => {
      if (fileAssociacaoGrupos.value == null) {
        quasar.notify({
          message: "Selecione um arquivo primeiro",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (fileAssociacaoGrupos.value.name.split(".").pop() != "xlsx") {
        quasar.notify({
          message: "O arquivo tem que ser do tipo .xlsx",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("treinamento/uploadAssociacaoMassa", {
          unidadeId: unidade.value.id,
          arquivo: arquivoAssociacaoGruposUrl.value.split("base64,")[1],
        });
        quasar.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        fileAssociacaoGrupos.value = null;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarArquivoTreinamento = async () => {
      if (fileTreinamento.value == null) {
        quasar.notify({
          message: "Selecione um arquivo primeiro",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (fileTreinamento.value.name.split(".").pop() != "xlsx") {
        quasar.notify({
          message: "O arquivo tem que ser do tipo .xlsx",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("treinamento/uploadTreinamento", {
          unidadeId: unidade.value.id,
          arquivo: arquivoTreinamento.value.split("base64,")[1],
        });
        quasar.notify({
          message: "Upload feito com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        fileTreinamento.value = null;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao fazer upload",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    watch(
      () => file.value,
      () => {
        if (file.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(file.value);
          fileReader.addEventListener("load", () => {
            arquivoUrl.value = fileReader.result;
          });
        }
      }
    );

    watch(
      () => fileAssociacaoGrupos.value,
      () => {
        if (fileAssociacaoGrupos.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(fileAssociacaoGrupos.value);
          fileReader.addEventListener("load", () => {
            arquivoAssociacaoGruposUrl.value = fileReader.result;
          });
        }
      }
    );

    watch(
      () => fileTreinamento.value,
      () => {
        if (fileTreinamento.value != null) {
          let fileReader = new FileReader();

          fileReader.readAsDataURL(fileTreinamento.value);
          fileReader.addEventListener("load", () => {
            arquivoTreinamento.value = fileReader.result;
          });
        }
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      unidade,
      onFileSelected,
      onFileSelectedGrupos,
      file,
      informacao,
      enviarArquivo,
      arquivoUrl,
      slide,
      fileAssociacaoGrupos,
      arquivoAssociacaoGruposUrl,
      enviarArquivoAssociacaoGrupos,
      informacaoAssociacaoGrupos,
      slideAssocoacaoGrupos,
      informacaoTreinamento,
      fileTreinamento,
      enviarArquivoTreinamento,
      arquivoTreinamento,
      onFileSelectedTreinamento,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-upload {
  margin: 9px 0px 0px 0px;
}
a {
  text-decoration: none;
  color: white;
}
@media (max-width: 600px) {
  @media (max-width: 600px) {
    .texto-titulo {
      font-size: 14px;
      margin-top: 10px;
    }
    .container-inputs {
      margin: 0px 0px 0px 0px;
    }
    .texto-titulo-input {
      font-size: 12px;
      margin: 0px;
    }

    .select {
      font-size: 12px;
    }
    .btn {
      margin: 0px 0px 0px 0px;
      font-size: 12px;
    }
    .btn-enviar {
      margin: 8px 0px 0px 0px;
      font-size: 12px;
    }
    .texto-upload {
      font-size: 8px;
      display: none;
    }
  }
}
</style>
